function FormatCompute (money, unit, remainDecimal = true) { // unit 单位  remainDecimal 是否保留小数（2位）
  unit = unit || '';
  // if (money < 0) return `-0.00${unit}`;
  var str = money.toFixed(2) + '';
  var intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ','); // 取到整数部分
  var dot = str.substring(str.length, str.indexOf('.')) // 取到小数部分搜索
  if (remainDecimal) {
    return `${intSum}${dot}${unit}`;
  } else {
    return `${intSum}`;
  }
}

export function formatMoney (money, unit = '') { // money 可以为数字也可以是字符串 不符合金额要求的money，会统一返回 0.00，有单位就会加上单位  unit 金额的单位
  if (money) {
    if (typeof money === 'number') {
      return FormatCompute(money, unit);
    } else if (typeof money === 'string') {
      if (isNaN(money)) {
        return `0.00${unit}`;
      } else {
        return FormatCompute(parseFloat(money), unit);
      }
    }
  }
  return `0.00${unit}`;
}
export function formatNumber (num) { // num 正整数和0
  if (num) {
    if (typeof num === 'number') {
      return FormatCompute(num, '', false);
    } else if (typeof num === 'string') {
      if (isNaN(num)) {
        return `0`;
      } else {
        return FormatCompute(parseInt(num), '', false);
      }
    }
  }
  return `0`;
}
export function formatNumberPercent (numObj, digit = 2, isTimes100 = true) { // num 百分比
  let result = 0
  if (!isNaN(numObj)) {
    let num = Number(numObj)
    if (isTimes100) {
      result = num
    } else {
      result = num * 100.0
    }
  }
  return `${result.toFixed(digit)}%`;
}



// WEBPACK FOOTER //
// ./utils/moneyFormat.js